import { css } from '@emotion/css';

export const canvas = ({ width, height }) => css`
  label: size-legend-canvas;
  width: ${width}px;
  height: ${height}px;
`;
